import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star } from "lucide-react";
import { ReviewCard, TESTIMONIALS } from "../components/landing/TestimonialSection";

const RED = "#C41E24", GOLD = "#D4AF37";
const LOGO = "/brand/nexto-academy-horizontal.png";

// Standalone branded review graphic — rendered by scripts/render_reviews.py.
// /print/review/:i/:fmt  (i = 1..4, fmt = square 1080×1080 | portrait 1080×1350)
export default function PrintReview() {
  const { i, fmt } = useParams();
  const idx = Math.min(Math.max(Number(i) - 1, 0), TESTIMONIALS.length - 1);
  const t = TESTIMONIALS[idx];
  const portrait = fmt === "portrait";
  const H = portrait ? 1350 : 1080;
  const [ready, setReady] = useState(false);
  useEffect(() => {
    Promise.all([document.fonts.ready, new Promise((r) => { const im = new Image(); im.onload = im.onerror = r; im.src = LOGO; })]).then(() => setReady(true));
  }, []);
  return (
    <div className="bg-black min-h-screen flex items-start justify-start">
      <div data-testid="print-review" data-ready={ready ? "1" : "0"} className="relative overflow-hidden text-white elite-carbon-bg grain flex flex-col" style={{ width: 1080, height: H, fontFamily: "Montserrat, sans-serif" }}>
        <div className="absolute inset-0 pointer-events-none" style={{ background: `radial-gradient(760px 460px at 50% 0%, ${GOLD}2e, transparent 70%), radial-gradient(800px 520px at 50% 110%, ${RED}26, transparent 70%)` }} />
        {[["top-0 left-0", "border-t-4 border-l-4"], ["top-0 right-0", "border-t-4 border-r-4"], ["bottom-0 left-0", "border-b-4 border-l-4"], ["bottom-0 right-0", "border-b-4 border-r-4"]].map(([pos, b]) => (
          <div key={pos} className={`absolute ${pos} ${b} w-16 h-16 m-7`} style={{ borderColor: `${GOLD}88` }} />
        ))}

        {/* header: official horizontal lockup top-left */}
        <div className="relative flex items-center justify-between" style={{ padding: "58px 72px 0" }}>
          <img data-testid="print-review-logo" src={LOGO} alt="The Next O Technical Academy" style={{ height: 96, filter: `drop-shadow(0 0 22px ${GOLD}55)` }} />
          <div className="flex items-center gap-2 font-mono font-bold uppercase" style={{ fontSize: 15, letterSpacing: "0.38em", color: GOLD }}><Star size={14} fill={GOLD} /> Central Illinois Families</div>
        </div>

        {/* body */}
        <div className="relative flex-1 flex flex-col justify-center" style={{ padding: "0 90px" }}>
          {portrait && (
            <h1 className="font-cover uppercase text-center leading-[0.88]" style={{ fontSize: 96, marginBottom: 64, textShadow: `0 0 40px ${GOLD}44` }}>What Parents<br />Are <span style={{ color: GOLD }}>Saying</span></h1>
          )}
          <ReviewCard t={t} index={idx} big />
        </div>

        {/* footer */}
        <div className="relative flex items-center justify-between" style={{ height: 84, background: RED, padding: "0 64px" }}>
          <div className="font-headings uppercase" style={{ fontSize: 24, letterSpacing: "0.06em" }}>The Next O Technical Academy</div>
          <div className="font-mono font-bold uppercase" style={{ fontSize: 15, letterSpacing: "0.3em" }}>nextosoccer.com</div>
          <div className="font-cover" style={{ fontSize: 32 }}>$49 · Volume 1 Blueprint</div>
        </div>
      </div>
    </div>
  );
}
